// @ts-nocheck
/* eslint-disable */
export const searchIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.333 13.833a6 6 0 1 0 0-12 6 6 0 0 0 0 12m5.287.46c.353 1.067 1.16 1.174 1.78.24.566-.853.193-1.553-.834-1.553-.76-.007-1.186.586-.946 1.313"/></svg>`,
    name: 'search' as const
};